<template>
    <div v-loading="dataLoading">
        <el-alert type="warning"><div slot="title">注意：秀动的数据只对应这几个支付账号，其余支付账号（paypal）和三方订单没有包含在内</div></el-alert>
        <div v-if="data">
            <el-card :header="`对账日期：${data.time}`" class="card1 MT20">
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">支付平台总收入：</label><b>{{ data.platformTotalAmount }}</b>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">支付平台总交易笔数：</label><b>{{ data.platformTotalNum }}</b>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">对账成功总金额：</label><b>{{ data.billSuccessAmount }}</b>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">秀动总收入：</label><b>{{ data.totalAmount }}</b>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">秀动总交易笔数：</label><b>{{ data.totalNum }}</b>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <label class="color-info">对账成功总笔数：</label><b>{{ data.billSuccessTotalNum }}</b>
                    </el-col>
                </el-row>
            </el-card>
			<div class="heightAuto">
				<!-- <div v-for="(item, index) in data.details" :key="index" class="MT20">
					<el-card :header="payPlatform[item.type]" class="card2" >
					    <div class="item">
					        <label class="color-info">支付平台总收入：</label><b>{{ item.platformTotalAmountStr }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">秀动总收入：</label><b>{{ item.totalAmountStr }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">对账成功总收入：</label><b>{{ item.billSuccessAmountStr }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">支付平台服务费：</label><b>{{ item.platformPoundageStr }}</b>
					    </div>
					    <div class="item MT30">
					        <label class="color-info">支付平台交易笔数：</label><b>{{ item.platformTotalNum }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">秀动交易笔数：</label><b>{{ item.totalNum }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">对账成功交易笔数：</label><b>{{ item.billSuccessTotalNum }}</b>
					    </div>
					    <div class="item MT30">
					        <label class="color-info">支付平台多出：</label><b>{{ item.platformRedundantNum }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">秀动订单多出：</label><b>{{ item.redundantNum }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">金额有差异：</label><b>{{ item.inconsistentAmountNum }}</b>
					    </div>
					    <div class="item MT15">
					        <label class="color-info">重复支付：</label><b>{{ item.repeatNum }}</b>
					    </div>
					</el-card>
				</div> -->
				<el-table :data="data.details" border style="width: 100%"  size="small" stripe class="MT20">
				    <el-table-column prop="typeView" label="支付渠道">
						<!-- <template slot-scope="scope">
							{{payPlatform[scope.row.type]}}
						</template> -->
					</el-table-column>
				    <el-table-column label="支付平台总收入" prop="platformTotalAmountStr"></el-table-column>
				    <el-table-column label="秀动总收入" prop="totalAmountStr"></el-table-column>
				    <el-table-column label="对账成功总收入" prop="billSuccessAmountStr"></el-table-column>
				    <el-table-column label="支付平台服务费" prop="platformPoundageStr" min-width="140"></el-table-column>
				    <el-table-column label="支付平台交易笔数" prop="platformTotalNum"></el-table-column>
				    <el-table-column label="秀动交易笔数" prop="totalNum" min-width="150"></el-table-column>
				    <el-table-column label="对账成功交易笔数" prop="billSuccessTotalNum"></el-table-column>
				    <el-table-column label="支付平台多出" prop="platformRedundantNum"></el-table-column>
				    <el-table-column label="秀动订单多出" prop="redundantNum"></el-table-column>
				    <el-table-column label="金额有差异" prop="inconsistentAmountNum"></el-table-column>
					<el-table-column label="重复支付" prop="repeatNum"></el-table-column>
				</el-table>
			</div>           
        </div>

        <div class="group clear" v-loading="abnormalLoading">
            <div class="page-group-title"><span>异常数据</span></div>
            <template v-if="abnormal">
                <el-card v-if="abnormal.platformList && abnormal.platformList.length > 0" class="MT20">
                    <div slot="header" class="card-header">
                        <div class="title"><b>支付平台多出订单：</b>在{{abnormal.time}}之间，有<span class="color-danger">{{abnormal.platformNum}}</span>个订单仅在支付平台存在</div>
                        <div class="btn"><el-link type="primary" :href="`/finance/statement/abnormal/list?type=1&timeType=2&startTime=${time}&endTime=${time}`">去列表处理<span class="el-icon-right"></span></el-link></div>
                    </div>
                    <el-table :data="abnormal.platformList" size="mini" max-height="400">
                        <el-table-column label="订单编号" prop="orderSn" min-width="130"></el-table-column>
                        <el-table-column label="支付渠道" prop="payPlatform"></el-table-column>
                        <el-table-column label="支付平台交易号" prop="outTradeNo" min-width="220"></el-table-column>
                        <el-table-column label="支付金额" prop="payPrice"></el-table-column>
                        <el-table-column label="支付状态" prop="payStatus"></el-table-column>
                        <el-table-column label="创建时间" prop="createTime" min-width="150"></el-table-column>
                        <el-table-column label="支付时间" prop="successTime" min-width="150"></el-table-column>
                    </el-table>
                </el-card>
                <el-card v-if="abnormal.repeatList && abnormal.repeatList.length > 0" class="MT20">
                    <div slot="header" class="card-header">
                        <div class="title"><b>订单重复支付：</b>在{{abnormal.time}}之间，有<span class="color-danger">{{abnormal.repeatNum}}</span>个订单出现了重复支付</div>
                        <div class="btn"><el-link type="primary" :href="`/finance/statement/repeatOrder/list?dateType=2&startTime=${dTime + ' 00:00:00'}&endTime=${dTime + ' 23:59:59'}`">去列表处理<span class="el-icon-right"></span></el-link></div>
                    </div>
                    <el-table :data="abnormal.repeatList" size="mini" max-height="400">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-row :gutter="30" v-for="(item,index) in props.row.repeatList" :key="index" class="MT10">
                                    <el-col :xs="24" :sm="10">
                                        <label class="color-info">{{payPlatform[item.payPlatform]}}交易号：</label>
                                        <span>{{item.outTradeNo}}</span>
                                    </el-col>
                                    <el-col :xs="24" :sm="10">
                                        <label class="color-info">{{payPlatform[item.payPlatform]}}支付时间：</label>
                                        <span>{{item.successTime}}</span>
                                    </el-col>
                                </el-row>
                            </template>
                        </el-table-column>
                        <el-table-column label="支付状态" prop="payStatus"></el-table-column>
                        <el-table-column label="订单状态" prop="orderStatus"></el-table-column>
                        <el-table-column label="订单ID" prop="orderId"></el-table-column>
                        <el-table-column label="订单编号" prop="orderSn" min-width="140"></el-table-column>
                        <el-table-column label="购买人ID" prop="createUser"></el-table-column>
                        <el-table-column label="下单时间" prop="createTime" min-width="150"></el-table-column>
                        <el-table-column label="总价" prop="totalAmount"></el-table-column>
                        <el-table-column label="优惠" prop="discount"></el-table-column>
                        <el-table-column label="实际支付" prop="payPrice"></el-table-column>
                        <el-table-column label="演出ID" prop="activityId"></el-table-column>
                    </el-table>
                </el-card>
                <el-card v-if="abnormal.showStartList && abnormal.showStartList.length > 0" class="MT20">
                    <div slot="header" class="card-header">
                        <div class="title"><b>秀动订单多出：</b>在{{abnormal.time}}之间，有<span class="color-danger">{{abnormal.showStartNum}}</span>个订单仅在秀动存在</div>
                        <div class="btn"><el-link type="primary" :href="`/finance/statement/abnormal/list?type=0&timeType=2&startTime=${time}&endTime=${time}`">去列表处理<span class="el-icon-right"></span></el-link></div>
                    </div>
                    <el-table :data="abnormal.showStartList" size="mini" max-height="400">
                        <el-table-column label="业务" prop="orderType">
                            <template slot-scope="scope">{{orderType[scope.row.orderType]}}</template>
                        </el-table-column>
                        <el-table-column label="订单ID" prop="orderId"></el-table-column>
                        <el-table-column label="订单编号" prop="orderSn" min-width="130"></el-table-column>
                        <el-table-column label="支付渠道" prop="payPlatform"></el-table-column>
                        <el-table-column label="支付平台交易号" prop="outTradeNo" min-width="220"></el-table-column>
                        <el-table-column label="实际支付" prop="payPrice"></el-table-column>
                        <el-table-column label="支付状态" prop="payStatus"></el-table-column>
                        <el-table-column label="订单状态" prop="orderStatus"></el-table-column>
                        <el-table-column label="下单时间" prop="createTime" min-width="150"></el-table-column>
                        <el-table-column label="支付时间" prop="successTime" min-width="150"></el-table-column>
                        <el-table-column label="下单终端" prop="terminal"></el-table-column>
                    </el-table>
                </el-card>
                <el-card v-if="abnormal.amountList && abnormal.amountList.length > 0" class="MT20">
                    <div slot="header" class="card-header">
                        <div class="title"><b>订单金额差异：</b>在{{abnormal.time}}之间，有<span class="color-danger">{{abnormal.amountNum}}</span>个订单的收入金额在秀动和支付平台不一致</div>
                        <div class="btn"><el-link type="primary" :href="`/finance/statement/abnormal/list?type=2&timeType=2&startTime=${time}&endTime=${time}`">去列表处理<span class="el-icon-right"></span></el-link></div>
                    </div>
                    <el-table :data="abnormal.amountList" size="mini" max-height="400">
                        <el-table-column label="业务" prop="orderType">
                            <template slot-scope="scope">{{orderType[scope.row.orderType]}}</template>
                        </el-table-column>
                        
                        <el-table-column label="秀动订单编号" prop="orderSn" min-width="130"></el-table-column>
                        <el-table-column label="支付渠道" prop="payPlatform"></el-table-column>
                        <el-table-column label="支付平台交易号" prop="outTradeNo" min-width="220"></el-table-column>
                        <el-table-column label="秀动支付金额" prop="payPrice"></el-table-column>
                        <el-table-column label="平台支付金额" prop="platformPayPrice"></el-table-column>
                        <el-table-column label="支付时间" prop="successTime" min-width="150"></el-table-column>
                    </el-table>
                </el-card>
            </template>
        </div>

        <div class="MT30">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="$utils.have('/finance/rawDataExport')" type="primary"
                @click="download" :loading="downLoading">下载支付平台原始对账单</el-button>
        </div>
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';

export default {
    data() {
        return {
            data: null,
            dataLoading: false,
            time: this.$route.query.time,
            dTime: this.$route.query.time,
            payPlatform: {
                1: '支付宝',
                2: '微信',
                3: '财付通',
                4: '抖音',
				5: '云闪付',
				6: '美团支付'
            },
            orderType: {
                1: '演出',
                2: '众筹',
                3: '周边',
				7: '演出会员',
            },
            redirect: this.$route.query.redirect || '/finance/statement/list',
            abnormal: null,
            abnormalLoading: false,
            downLoading: false,
        }
    },
    computed:{
        userInfo(){
            return this.$store.state.userInfo;
        }
    },
    mounted() {
        this.time = this.time.replaceAll('-', '')
        this.getDetail();
        this.getAbnormalDataReference();
    },
    methods: {
        //获取详情
        async getDetail() {
            this.dataLoading = true;
            const res = await this.$request({
                url: "/finance/statementDetails",
                method: "POST",
                params: {
                    date: this.time
                },
            })
                .catch(err => {
                    return this.$message({ message: err.message, type: 'error' });
                })
                .finally(() => {
                    this.dataLoading = false;
                });
            const { state, msg, result } = res.data;
            if (state == 1) {
                this.data = result;
            } else {
                return this.$message.error(msg || '请求失败');
            }
        },
        //异常数据参考
        async getAbnormalDataReference() {
            this.abnormalLoading = true;
            const res = await this.$request({
                url: "/finance/abnormalDataReference",
                method: "POST",
                params: {
                    date: this.time
                },
            })
                .catch(err => {
                    return this.$message({ message: err.message, type: 'error' });
                })
                .finally(() => {
                    this.abnormalLoading = false;
                });
            const { state, msg, result } = res.data;
            if (state == 1) {
                this.abnormal = result;
            } else {
                return this.$message.error(msg || '请求失败');
            }
        },
        //下载原始数据
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: "/finance/rawDataExport",
                method: "POST",
                params: {
                    date: this.time
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,`对账平台原始对账单_.${this.userInfo.name}_${this.data.time}.`+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
b {
    font-weight: 700;
}
.clear{
	clear: both;
	margin-top: 30px;
}
.card1 {
    .el-col {
        margin: 10px 0;
    }
}
.heightAuto{
	height: 100%;
	overflow: hidden;
}
.card2 {	
	width: 18%;
	float: left;
	margin-right: 30px;
    .item {
        display: flex;
        justify-content: space-between;
    }
}

.card-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>